import Vue from 'vue'
import moment from "moment"

Vue.filter("formatDate", formatDate);
Vue.prototype.formatDate = formatDate;

function formatDate(value) {
    return moment(value).format('YYYY-MM-DD');
}

Vue.filter("formatDateTime", formatDateTime);
Vue.prototype.formatDateTime = formatDateTime;

function formatDateTime(value) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
}

Vue.filter("formatDateForApple", formatDateForApple);
Vue.prototype.formatDateForApple = formatDateForApple;

function formatDateForApple(value) {
    return moment(value).format();
}




// WEBPACK FOOTER //
// ./src/utils/filter_utils.js